const initialState = {
  isPopoverOpen: false,
  siteSelected: null,
  siteSvgId: null,
}

const mapReducer = (state, { payload }) => ({ ...state, ...payload })

export { initialState, mapReducer }
